// import { request } from "https";
// const https = require('node:https');
import axios from "axios";
import { URL } from "url";

const resolveContentType = (
  data: BlobPart,
  addContentType: boolean
): string => {
  if (addContentType) {
    return "application/json; charset=utf-8";
  }

  if (typeof Blob !== "undefined" && data instanceof Blob && data.type) {
    return data.type;
  }

  return "application/octet-stream";
};

export const s3Put = async (
  url: string | URL,
  data: BlobPart,
  addContentType: boolean = false
) => {
  const config = {
    headers: {
      "Content-Type": resolveContentType(data, addContentType),
      "Cache-Control": "public, max-age=31536000, immutable",
    },
  };
  await axios.put(url as string, data, config);
};
